module.exports = __webpack_public_path__ + "img/empty-state.e2befa9f.png";